import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n, {loadLocaleMessagesAsync} from "@/i18n";
import Root from "./Root"
import {
    setDocumentDirectionPerLocale,
    setDocumentLang,
    setDocumentTitle
} from "@/util/i18n/document";
import vueStore from "../vueStore";

const HomePage = () => import(/* webpackChunkName: "screens" */ '../screens/home/Home.vue')
const SectionDetail = () => import(/* webpackChunkName: "screens" */ '../screens/section-detail/SectionDetail.vue')
const ProjectDetail = () => import(/* webpackChunkName: "screens" */ '../screens/project-detail/ProjectDetail.vue')

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        redirect: i18n.locale
    },
    {
        path: "/:locale",
        component: Root,
        children: [
            {
                path: "",
                name: "home",
                meta: {
                    title: "pages.home"
                },
                component: HomePage
            },
            {
                path: "project/:projectId",
                name: "projectDetail",
                meta: {
                    title: "pages.projectDetail"
                },
                component: ProjectDetail
            },
            {
                path: ":urbanEnvironmentOrGeography/:section",
                name: "sectionDetail",
                meta: {
                    title: "pages.sectionDetail"
                },
                component: SectionDetail
            },
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    }
})

const DEFAULT_TITLE = "app.title";
const DEFAULT_DESCRIPTION = "app.description";
const DEFAULT_AFTER_TITLE = " | Enel X";

router.afterEach((to, from) => {

    Vue.nextTick(() => {
        let titleText = '';
        let metaDescriptionText = '';

        if (to.params.section) {
            let activeUrbanEnvironmentOrGeography = vueStore.getters.getActiveUrbanEnvironmentOrGeography;
            let sectionKey = vueStore.getters.getSectionKey(activeUrbanEnvironmentOrGeography, to.params.section)
            titleText = `${activeUrbanEnvironmentOrGeography}.${sectionKey}.metaTitle`;
            metaDescriptionText = `${activeUrbanEnvironmentOrGeography}.${sectionKey}.metaDescription`;
        } else if (to.params.projectId) {
            let project = vueStore.getters.getProjectById(to.params.projectId)
            titleText = `projects.${project.id}.metaTitle`;
            metaDescriptionText = `projects.${project.id}.metaDescription`;
        }

        let title = (i18n.t(titleText) || i18n.t(DEFAULT_TITLE));
        let metaDescription = (i18n.t(metaDescriptionText) || i18n.t(DEFAULT_DESCRIPTION));

        document.title = title + DEFAULT_AFTER_TITLE;
        window.title = title;
        window.metaDescription = metaDescription;

        document.querySelector('meta[name="title"]').setAttribute("content", title + DEFAULT_AFTER_TITLE);
        document.querySelector('meta[name="description"]').setAttribute("content", window.metaDescription);


        // ANALYTICS
        var enelDataPageView = {
            page: {
                pageInfo: {
                    pageName: document.title,
                    pageURL: document.URL,
                },
                attributes: {
                    country: 'IT',
                    language: i18n.locale
                }
            },
        }

        window.satelliteTrack('pageview', enelDataPageView);
    });
});

router.beforeEach((to, from, next) => {
    if (to.params.locale === from.params.locale) {
        next()
        return
    }

    const {locale} = to.params

    loadLocaleMessagesAsync(locale).then(() => {
        setDocumentLang(locale)
        setDocumentDirectionPerLocale(locale)

        let title = i18n.t(window.title) + DEFAULT_AFTER_TITLE;
        let metaDescription = i18n.t(window.metaDescription);

        setDocumentTitle(title)
        document.querySelector('meta[name="title"]').setAttribute("content", title);
        document.querySelector('meta[name="description"]').setAttribute("content", metaDescription);
    })

    next()
})

export default router
